import React, {Component} from 'react';
import PropTypes from 'prop-types';
import './Parallax.css';
import Home from '../../views/home/Home.jsx';
import OurProducts from "../../views/ourProducts/OurProducts";
import WhereToBuy from "../../views/whereToBuy/WhereToBuy";
import Contact from "../../views/contact/Contact";
import ViewLayout from "./ViewParallaxLayout";


/**
 * BaseLayout - Global Component
 *
 * @class ParallaxLayout
 * @namespace Architect\React\Global
 * @author Mike Rudling <mrudling@wearearchitect.com>
 */
export default class ParallaxLayout extends Component {

    /**
     * Default props
     *
     *  CMS - Accepted values are "None", "Wordpress", "Craft", "October"
     *
     * @type {{cms: string}}
     */
    static defaultProps = {
        cms: "Craft"
    };

    /**
     * Prop Types
     *
     * @type {{}}
     */
    static propTypes = {
        cms: PropTypes.string
    };

    /**
     * State
     *
     * @type {{}}
     */
    state = {};

    /**
     * Render
     *
     * @returns {XML}
     */
    render() {
        const {cms} = this.props;

        return (
            <div className="ParallaxLayout">

                <ViewLayout
                    exact
                    path="/"
                    component={Home}/>
                <ViewLayout
                    exact
                    path="/our-products"
                    component={OurProducts}
                    cms={cms}
                    title="Our Products"
                    description="This is the Our Products description from the local."/>
                <ViewLayout
                    exact
                    path="/where-to-buy"
                    component={WhereToBuy}
                    cms={cms}
                    title="Where To Buy"
                    description="This is the Where To Buy description from the local."/>
                <ViewLayout
                    exact
                    path="/contact"
                    component={Contact}
                    cms={cms}
                    title="Contact Local"
                    description="This is the contact description from the local."/>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/layout/ParallaxLayout.jsx